import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/homePage.vue'
import DiseaseAnalysisPage from '@/views/DiseaseAnalysisPage.vue'
import LoginPage from '@/views/LoginPage.vue'
// import { checkAuth } from '@/utils/auth.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { requiresGuest: true } // 已登录用户不能访问登录页
  },
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/disease-analysis',
    name: 'DiseaseAnalysisPage',
    component: DiseaseAnalysisPage,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
// router.beforeEach((to, from, next) => {
//   const isAuthenticated = checkAuth();
  
//   // 需要登录的页面
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!isAuthenticated) {
//       // 未登录，跳转到登录页
//       next('/login');
//     } else {
//       next();
//     }
//   }
//   // 登录页面（已登录用户不应该访问）
//   else if (to.matched.some(record => record.meta.requiresGuest)) {
//     if (isAuthenticated) {
//       // 已登录，跳转到主页
//       next('/');
//     } else {
//       next();
//     }
//   }
//   // 其他页面
//   else {
//     next();
//   }
// });

export default router